import slotTypePositionCalculator from './SlotTypePositionCalculator';

export default function conditionPositionCalculator(sportType, groupType, slot) {
    let position = slotTypePositionCalculator(sportType, groupType, slot);

    return position + (slot.condition || 0);
}


// WEBPACK FOOTER //
// ./js/sport-betting/components/grid-control/slot-arrangement-policies/positionCalculators/ConditionPositionCalculator.js